import { NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLogoutMutation } from '../slices/usersApiSlice';
import { logout } from '../slices/authSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMountainSun } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
  const { userInfo } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      navigate('/');
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <header id="main-header">
        <div className="container">
            <h1><span className="logo"><FontAwesomeIcon icon={faMountainSun} />Sugarloaf</span>Homestead</h1>
        </div>
        { userInfo ? (
                <NavDropdown title={userInfo.username} id='username' className='non-printable'>
                  <LinkContainer to='/dashboard'>
                    <NavDropdown.Item>
                      Dashboard
                    </NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to='/dashboard/posts'>
                    <NavDropdown.Item>
                      - Posts
                    </NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to='/dashboard/videos'>
                    <NavDropdown.Item>
                      - Videos
                    </NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to='/dashboard/gallery'>
                    <NavDropdown.Item>
                      - Pictures
                    </NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to='/dashboard/recipes'>
                    <NavDropdown.Item>
                      - Recipes
                    </NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to='/dashboard/profile'>
                    <NavDropdown.Item>
                      Profile
                    </NavDropdown.Item>
                  </LinkContainer>
                  <NavDropdown.Item onClick={logoutHandler}>
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <div></div>
              )}
    </header>
  )
}

export default Header